import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';
import { formatCount } from '@/utils/format';

interface RelatedTopicsProps {
  currentId: number;
  categoryId: string;
}

export default function RelatedTopics({ currentId, categoryId }: RelatedTopicsProps) {
  const related = [
    ...topics.filter((topic) => topic.id !== currentId && topic.categoryId === categoryId),
    ...topics.filter((topic) => topic.id !== currentId && topic.categoryId !== categoryId),
  ].slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-14">
        <h2 className="font-heading text-xl font-bold text-foreground-950">相关话题推荐</h2>
        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
          {related.map((topic) => (
            <Link
              key={topic.id}
              to={`/topic/${topic.id}`}
              className="group flex gap-4 border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <span className="h-20 w-24 shrink-0 overflow-hidden bg-background-200">
                <img
                  src={topic.cover}
                  alt={`${topic.title} 话题配图`}
                  title={`${topic.title} - ${topic.categoryName}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </span>
              <span className="flex flex-1 flex-col">
                <span className="text-xs text-secondary-700">{topic.categoryName}</span>
                <span className="mt-1 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
                  {topic.title}
                </span>
                <span className="mt-auto flex items-center gap-3 pt-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500" aria-hidden="true" />
                    {formatCount(topic.heat)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line" aria-hidden="true" />
                    {formatCount(topic.comments)}
                  </span>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}